import { Routes } from '@angular/router';

import { Shell } from '@app/shell/shell.service';

export const appRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@app/auth/login.component').then((m) => m.LoginComponent),
    data: { title: 'Login' },
  },
  Shell.childRoutes([
    { path: '', pathMatch: 'full', redirectTo: 'about' },
    {
      path: 'about',
      loadComponent: () => import('@app/about/about.component').then((m) => m.EngAboutComponent),
      data: { title: 'About Us' },
    },
    {
      path: 'projects/overseas',
      loadComponent: () => import('@app/projects/overseas/overseas.component').then((m) => m.EngOverseasComponent),
      data: { title: 'JTS Overseas Projects' },
    },
    {
      path: 'projects/southkorea',
      loadComponent: () =>
        import('@app/projects/southkorea/southkorea.component').then((m) => m.EngSouthkoreaComponent),
      data: { title: 'JTS Projects in South Korea' },
    },
    {
      path: 'donate',
      loadComponent: () => import('@app/donate/donate.component').then((m) => m.EngDonateComponent),
      data: { title: 'How To Donate' },
    },
  ]),
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
